
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {ServiceNomenclatureRequestType} from "@/form/service/serviceNomenclature.types";
import {IServicesNomenclaturesListItem} from "@/entity/servicesNomenclature/services.nomenclature.types";

@Component
export default class ServiceNomenclatureForm extends Form {
    service_id = 0;
    @Validate(required, i18nText("Введите название услуги"))
    name = '';
    online_appointment_name = '';
    description = '';
    price_first: number = 0;
    price_second: number = 0;
    @Validate(required, i18nText("Введите длительность услуги"))
    service_duration = '';
    image = 1;
    @Validate(required, i18nText("Выберите название услуги"))
    category_id: number | null = null;
    //categorys   : IServicesCategory | null = null;
    @Validate(required, i18nText("Является ли запись онлайн"))
    online_appointment: boolean = false;
    @Validate(required, i18nText("Является ли запись активной"))
    active: boolean = false;
    key = 0;

    getFormData(): ServiceNomenclatureRequestType {
        return {
            id: this.service_id,
            name: this.name,
            description: this.description,
            online_appointment_name: this.online_appointment_name,
            price_first: this.price_first,
            price_second: this.price_second,
            service_duration: this.service_duration,
            category_id: this.category_id,
            image: this.image,
            active: this.active,
            online_appointment: this.online_appointment,
        }
    }

    setFormData(service: IServicesNomenclaturesListItem | null): void {
        if (service !== undefined && service != null) {
            this.service_id = service.id;
            this.active = service.active;
            this.name = service.name;
            this.description = service.description;
            this.online_appointment_name = service.online_appointment_name;
            this.price_first = service.price_first;
            this.price_second = service.price_second;
            this.service_duration = service.service_duration;
            this.category_id = service.category_id;
            this.image = service.image;
            this.online_appointment = service.online_appointment;
        }
    }
}
